import { Components, Theme } from '@mui/material/styles';
import { borderRadius } from '../foundations/shape';

export const MuiCard: Components<Theme>['MuiCard'] = {
  defaultProps: { variant: 'panel' },
  styleOverrides: {
    root: ({ ownerState }) => ({
      borderRadius: ownerState.variant === 'bare' ? 0 : borderRadius.large,
      overflow: 'hidden',
    }),
  },
};

export const MuiCardContent: Components['MuiCardContent'] = {
  styleOverrides: {
    root: {
      padding: '24px',
      '&:last-child': {
        paddingBottom: '24px',
      },
    },
  },
};
